// src/security/usePerfilPlano.js
import { useMemo } from 'react';
import { useBootstrap } from '../context/BootstrapContext';
import { PLANO_PADRAO } from './capacidades';
import { perfilDoPlano } from './perfisPlano';

/** Traços de apresentação do plano da conta (ver perfisPlano.js). */
export function usePerfilPlano() {
    const { bootstrap } = useBootstrap();
    const plano = String(bootstrap?.plan || PLANO_PADRAO).toUpperCase();
    return useMemo(() => perfilDoPlano(plano), [plano]);
}
